module.exports = __webpack_public_path__ + "static/img/noImg.4e85045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/word/noImg.png
// module id = +5Lg
// module chunks = 3